import React from 'react';
import ReactToPrint from 'react-to-print';
import { Button,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableRow,
  TableHead,
  Typography,} from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import Print from '@material-ui/icons/Print';
import ReportHeader from '../share/ReportHeader';

const styles = theme => ({
  root: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing.unit * 2,
    paddingBottom: theme.spacing.unit * 2,
    margin: theme.spacing.unit * 2,
  },
  rootNoRegs: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing.unit * 2,
    paddingBottom: theme.spacing.unit * 2,
  },
  button: {
    margin: theme.spacing.unit,
  },
  icon: {
    marginRight: theme.spacing.unit,
  },
  direita: {
    textAlign: 'right',
    width: '50%',
  },
  centro: {
    textAlign: 'center',
  },
  div: {
    ...theme.mixins.gutters(),
    paddingTop: theme.spacing.unit * 2,
    paddingBottom: theme.spacing.unit * 2,
    textAlign: 'center',
  },
  typography: {
    ...theme.mixins.gutters(),
    paddingBottom: theme.spacing.unit * 2,
    textAlign: 'center',
  },
  fontReport: {
    fontSize: 10
  }
});

class ComponentToPrint extends React.Component {
  render () {
    const { classes, beneficiarios, tituloConsulta } = this.props;
    return (
      <Paper className={classes.root} elevation={0}>
        <ReportHeader titulo={tituloConsulta + ' - ' + beneficiarios.length + ' registro(s)'} />
        {beneficiarios !== undefined && beneficiarios.length !== 0
            ? <Table padding={'default'}>
              <TableHead>
                <TableRow>
                  <TableCell className={classes.fontReport}>Matrícula</TableCell>
                  <TableCell className={classes.fontReport}>Nome</TableCell>
                  <TableCell className={classes.fontReport}>CPF</TableCell>
                  <TableCell className={classes.fontReport}>Titularidade</TableCell>
                  <TableCell className={classes.fontReport}>Dt. Nascimento</TableCell>
                  <TableCell className={classes.fontReport}>Idade</TableCell>
                  <TableCell className={classes.fontReport}>Est. Civil</TableCell>
                  <TableCell className={classes.fontReport}>Sexo</TableCell>
                  <TableCell className={classes.fontReport}>Parentesco</TableCell>
                  <TableCell className={classes.fontReport}>Data Início</TableCell>
                  <TableCell className={classes.fontReport}>Data Fim</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
              {beneficiarios.map((beneficiario, idx) => {
                  return (
                    <TableRow key={idx}>
                      <TableCell className={classes.fontReport}>{beneficiario.matricula}</TableCell>
                      <TableCell className={classes.fontReport}>{beneficiario.nome}</TableCell>
                      <TableCell className={classes.fontReport}>{beneficiario.cpf}</TableCell>
                      <TableCell className={classes.fontReport}>{beneficiario.titularidade}</TableCell>
                      <TableCell className={classes.fontReport}>{beneficiario.dataNasc}</TableCell>
                      <TableCell className={classes.fontReport}>{beneficiario.idade + ' ano(s)'}</TableCell>
                      <TableCell className={classes.fontReport}>{beneficiario.estadoCivil}</TableCell>
                      <TableCell className={classes.fontReport}>{beneficiario.sexo}</TableCell>
                      <TableCell className={classes.fontReport}>{beneficiario.parentesco}</TableCell>
                      <TableCell className={classes.fontReport}>{beneficiario.dataInicio}</TableCell>
                      <TableCell className={classes.fontReport}>{beneficiario.dataFim}</TableCell>
                    </TableRow>
                  );                  
                })
                }
              </TableBody>
            </Table>
          : <Paper className={classes.rootNoRegs} elevation={1}>
            <Typography className={classes.centro} component='p'>
              Não foram encontrados registros de beneficiários para este filtro.
            </Typography>
          </Paper>}
      </Paper>
    );
  }
}

class PrintComponentRelatorioBeneficiarios extends React.Component {
  render () {
    const { classes, beneficiarios, tituloConsulta } = this.props;
    return (
      <div>
        <ReactToPrint
          trigger={() =>
            <div className={classes.div}>
              <Button
                variant='contained'
                color='primary'
                className={classes.button}
                href='#'>
                <Print className={classes.icon} /> Imprimir / Salvar
              </Button>
            </div>}
          content={() => this.componentRef}
        />
        <ComponentToPrint
          ref={el => (this.componentRef = el)}
          tituloConsulta={tituloConsulta}
          beneficiarios={beneficiarios}
          classes={classes} />
      </div>
    );
  }
}
export default withStyles(styles)(PrintComponentRelatorioBeneficiarios);
